import React from 'react'

const Pagination = ({pages ,setcurrentPages , currentPages}) => {

    const genratedPages = [];

    for (let i = 1; i <= pages; i++) 
        genratedPages.push(i)

  return (
      <div className='Pagination'>
          
          {
              genratedPages.map((page) => {
                  return (
                      <div onClick={() => setcurrentPages(page)}
                     
                    className={currentPages === page ? "page active" : "page"}
                          
                          key={page}>
                          {page}
                      </div>
                  )
              })
          }

    </div>
  )
}

export default Pagination